import { CustomizationEntry } from "../types";

export enum VoiceCategory {
    CallBehavior = 'Call behavior',
    OutboundCalls = 'Outbound calls',
    Window = 'Window',
    Appearance = 'Appearance',
    CallControls = 'Call controls',
    Localization = 'Localization',
    Header = 'Header'
}

export enum VoiceSubCategory {
    Common = 'Common',
    Identity = 'Identity',
    AudioLevels = 'Audio levels',
    CallInformation = 'Call information',
    CampaignsAndTiming = 'Campaigns & timing',
    CallAnimations = 'Call animations',
    Size = 'Size',
    Theme = 'Theme',
    Colors = 'Colors',
    GradientAndAnimation = 'Gradient & animation',
    Orb = 'Orb',
    Typography = 'Typography',
    Layout = 'Layout',
    Icons = 'Icons',
    Controls = 'Controls',
    InterfaceText = 'Interface text',
}

export type VoiceCustomizationEntry = CustomizationEntry<VoiceCategory, VoiceSubCategory>;
